export default __webpack_public_path__ + "static/media/horror.2f5b3562.png";